export function getDataCompletionObjectForYear(defaults_data_completion, year) {
  if (!defaults_data_completion) return {}

  const ddc = {}
  for(const key in defaults_data_completion) {
    if(key == "id") continue
    const item = defaults_data_completion[key]
    ddc[key] = getItemForYear(item, year)
  }
  return ddc
}

function getItemForYear(data, year) {
  const completion = data.by_year.find(
    item => item.year == parseInt(year)
  )
  return completion
}
